import { PayeeType } from '@willow/graphql-iso/src/app/backend';

import { assertNever } from './assertNever';

export const formatPayeeType = (payeeType: PayeeType): string => {
  switch (payeeType) {
    case PayeeType.Tax:
      return 'Tax';
    case PayeeType.Insurance:
      return 'Insurance';
    case PayeeType.MortgageInsurance:
      return 'Mortgage Insurance';
    case PayeeType.Other:
      return 'Other';
    default:
      assertNever(payeeType);
  }
};
